import React from "react"
import { useTranslation } from 'react-i18next'
import MarketsButtonComponent from "./MarketsButtonComponent"

const RegistrationFooterComponent = (props) => {

    const { t } = useTranslation()

    return (
        <div id='splash-footer'>
            <div id='splash-footer-content'>
                <div className="member-benefits">
                    {props.isShgRegistration ? t('getstarted.member_benefits') : t('getstarted.how_it_works')}
                </div>
                <div className="line-3" />
                {!props.isShgRegistration && (
                    <div>
                        <div className='splash-footer-right col-md-9 col-xs-12'>
                            <div className='row splash-footer-section-row'>
                                <div className='splash-footer-section'>
                                    <div className='section-title  med-blue-color'>
                                        <i className='im-ss-mail'></i>
                                        {t('regftr.invites.title')}
                                    </div>
                                    {t('regftr.invites.subtitle')}
                                </div>
                                <div className='splash-footer-section'>
                                    <div className='section-title  med-blue-color'>
                                        <i className='im-ss-settings'></i>
                                        {t('regftr.stats.title')}
                                    </div>
                                    {t('regftr.stats.subtitle')}
                                </div>
                                <div className='splash-footer-section'>
                                    <div className='section-title med-blue-color'>
                                        <i className='im-currency'>
                                        <span className="path1"></span>
                                        <span className="path2 currency-reg"></span>
                                        <span className="path3"></span>
                                        <span className="path4 currency-reg"></span>
                                        <span className="path5"></span>
                                        <span className="path6 currency-reg"></span>
                                        <span className="path7"></span>
                                        <span className="path8 currency-reg"></span>
                                        <span className="path9"></span>
                                        <span className="path10 currency-reg"></span>
                                        <span className="path11"></span>
                                        <span className="path12 currency-reg"></span>
                                        <span className="path13"></span>
                                        <span className="path14 currency-reg"></span>
                                        <span className="path15"></span>
                                        <span className="path16 currency-reg"></span>
                                        </i>
                                        {t('regftr.earnings.title')}
                                    </div>
                                    {t('regftr.earnings.subtitle')}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {props.isShgRegistration && (
                    <div className='splash-footer-right'>
                        <div className='row splash-footer-section-row'>
                            <div className='splash-footer-section'>
                                <div className='os-benefits'>
                                    <i className='im-bubble3'></i>
                                    <p>{t('regftr.surveys.subtitle')}</p>
                                </div>
                            </div>
                            <div className='splash-footer-section'>
                                <div className='os-benefits'>
                                    <i className='im-lock2'></i>
                                    <p>{t('regftr.personal.subtitle')}</p>
                                </div>
                            </div>
                            <div className='splash-footer-section'>
                                <div className='os-benefits'>
                                <i className='im-currency'>
                                        <span className="path1"></span>
                                        <span className="path2 currency-reg"></span>
                                        <span className="path3"></span>
                                        <span className="path4 currency-reg"></span>
                                        <span className="path5"></span>
                                        <span className="path6 currency-reg"></span>
                                        <span className="path7"></span>
                                        <span className="path8 currency-reg"></span>
                                        <span className="path9"></span>
                                        <span className="path10 currency-reg"></span>
                                        <span className="path11"></span>
                                        <span className="path12 currency-reg"></span>
                                        <span className="path13"></span>
                                        <span className="path14 currency-reg"></span>
                                        <span className="path15"></span>
                                        <span className="path16 currency-reg"></span>
                                        </i>
                                    <p>{t('regftr.payment.subtitle')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {props.isShgRegistration && (
                    <div className="professionals-div">
                        <div className="line-3" />
                        <p className="professionals-msg">{t('regftr.markets.professionals_os')}</p>
                        <div className="line-3" />
                    </div>
                )}
                <div className='splash-footer-title'>
                    {t('regftr.qualified.title')}
                </div>
                <div className="line-3" />
                <div className='splash-footer-subtitle'>
                    {props.isShgRegistration ? t('regftr.markets.accepting_os') : t('regftr.markets.accepting')}
                </div>
                <div className='markets-list'>
                    <MarketsButtonComponent></MarketsButtonComponent>
                </div>
                {!props.isShgRegistration && (
                    <div>
                        <div className="member-benefits">
                            {t('getstarted.member_benefits')}
                        </div>
                        <div className="line-3" />
                        <div className="member-benefits-list">
                        <div className='member-benefits-text'>
                                <span className='member-benefits-checkmark med-green'>
                                    <i className='im-ss-check' />
                                </span>
                                {t('regftr.member_benefit_first_check')}
                            </div>
                            <div className='member-benefits-text'>
                                <span className='member-benefits-checkmark med-green'>
                                    <i className='im-ss-check' />
                                </span>
                                {t('regftr.member_benefit_second_check')}
                            </div>
                            <div className='member-benefits-text'>
                                <span className='member-benefits-checkmark med-green'>
                                    <i className='im-ss-check' />
                                </span>
                                {t('regftr.member_benefit_third_check')}
                            </div>
                            <div className='member-benefits-text'>
                                <span className='member-benefits-checkmark med-green'>
                                    <i className='im-ss-check' />
                                </span>
                                {t('regftr.member_benefit_fourth_check')}
                            </div>
                            <div className='member-benefit-subtitle'>
                                {t('regftr.member_benefit_first_subtitle')}
                            </div>
                            <div className='member-benefit-subtitle'>
                                {t('regftr.member_benefit_second_subtitle')}
                            </div>
                            </div>
                    </div>
                )}

                {props.isShgRegistration && (
                    <div className='os-registration-div'>
                        <div style={{ textAlign: "center" }}>
                            <i className="im-checkmark-circle"></i>
                        </div>
                        <p className="os-registration-text">{t('regftr.os_registration')}</p>
                        <p className="os-registration-subtext">{t('regftr.os_registration.subtitle')}</p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default RegistrationFooterComponent